// import spacer from './spacer/spacerReducer';
import ama from '@store/slices/blocks/ama/amaSlice.js';
import appointment from '@store/slices/blocks/appointment/appointmentSlice.js';
import banner from '@store/slices/blocks/banner/bannerSlice.js';
import blog from '@store/slices/blocks/blog/blogSlice.js';
import contacts from '@store/slices/blocks/contacts/contactsSlice.js';
import coupon from '@store/slices/blocks/coupon/couponSlice.js';
import course from '@store/slices/blocks/course/courseSlice.js';
import crowdfunding from '@store/slices/blocks/crowdfunding/crowdfundingSlice.js';
import dataCollect from '@store/slices/blocks/dataCollect/dataCollectSlice.js';
// Make and collect money
import digital from '@store/slices/blocks/digital/digitalSlice.js';
import discountBlock from '@store/slices/blocks/discountBlock/discountBlockSlice.js';
import donation from '@store/slices/blocks/donation/donationSlice.js';
import event from '@store/slices/blocks/event/eventSlice.js';
import faq from '@store/slices/blocks/faq/faqSlice.js';
import features from '@store/slices/blocks/features/featuresSlice.js';
import file from '@store/slices/blocks/file/fileSlice.js';
import footer from '@store/slices/blocks/footer/footerSlice.js';
import form from '@store/slices/blocks/form/formSlice.js';
import gallery from '@store/slices/blocks/gallery/gallerySlice.js';
import wall from '@store/slices/blocks/guestbook/guestbookSlice.js';
import header from '@store/slices/blocks/header/headerSlice.js';
import highlights from '@store/slices/blocks/highlights/highlightsSlice.js';
import html from '@store/slices/blocks/html/htmlSlice.js';
import instagram from '@store/slices/blocks/instagram/instagramSlice.js';
import link from '@store/slices/blocks/links/linksSlice.js';
import links from '@store/slices/blocks/links/linksSlice.js';
import map from '@store/slices/blocks/map/mapSlice.js';
import membership from '@store/slices/blocks/membership/membershipSlice.js';
import music from '@store/slices/blocks/music/musicSlice.js';
import nft from '@store/slices/blocks/nft/nftSlice.js';
import outfit from '@store/slices/blocks/outfit/outfitSlice.js';
import premiumInbox from '@store/slices/blocks/premiumInbox/premiumInboxSlice.js';
import pricing from '@store/slices/blocks/pricing/pricingSlice.js';
import promo from '@store/slices/blocks/promo/promoSlice.js';
import recipe from '@store/slices/blocks/recipe/recipeSlice.js';
import review from '@store/slices/blocks/review/reviewSlice.js';
import service from '@store/slices/blocks/service/serviceSlice.js';
import shop from '@store/slices/blocks/shop/shopSlice.js';
import slider from '@store/slices/blocks/slider/sliderSlice.js';
import spacer from '@store/slices/blocks/spacer/spacerSlice.js';
import splash from '@store/slices/blocks/splash/splashSlice.js';
import stat from '@store/slices/blocks/statistics/statisticsSlice.js';
import status from '@store/slices/blocks/status/statusSlice.js';
import text from '@store/slices/blocks/text/textSlice';
import tiktok from '@store/slices/blocks/tiktok/tiktokSlice.js';
import timeline from '@store/slices/blocks/timeline/timelineSlice.js';
import timer from '@store/slices/blocks/timer/timerSlice.js';
import trust from '@store/slices/blocks/trust/trustSlice.js';
import twitch from '@store/slices/blocks/twitch/twitchSlice.js';
import twitter from '@store/slices/blocks/twitter/twitterSlice.js';
import video from '@store/slices/blocks/video/videoSlice.js';
import videoFeedback from '@store/slices/blocks/videoFeedback/videoFeedbackSlice.js';
import wallet from '@store/slices/blocks/wallet/walletSlice.js';
import welcome from '@store/slices/blocks/welcome/welcomeSlice.js';
import youtube from '@store/slices/blocks/youtube/youtubeSlice.js';
import customTabPreview from '@store/slices/customTabPreview/customTabPreviewSlice.js';
import booking from '@store/toolkit/blocks/booking/bookingReducer.js';
import menu from '@store/toolkit/blocks/menu/menuReducer.js';
import podcast from '@store/toolkit/blocks/podcast/podcastReducer.js';

import custom from '@/store/slices/blocks/aiApp/aiAppSlice.ts';
import chatAi from '@/store/slices/blocks/chatAi/chatAiSlice.js';
import listing from '@/store/slices/blocks/listing/listingSlice.js';
import overview from '@/store/slices/blocks/overview/overviewSlice.js';
import pageList from '@/store/slices/blocks/page-list/pageListSlice.js';
import rental from '@/store/slices/blocks/rental/rentalSlice.js';
import singleProduct from '@/store/slices/blocks/singleProduct/singleProductSlice.js';
import team from '@/store/slices/blocks/team/teamSlice.js';
import timetable from '@/store/slices/blocks/timetable/timetableSlice.js';
import unlock from '@/store/slices/blocks/unlock/unlockSlice.js';

// import coupon from './coupon/couponReducer';
import courses from './courses/coursesReducer';
// import banner from './banner/bannerReducer';
// import map from './map/mapReducer';
// import slider from './slider/sliderReducer';
// import feature from './feature/featureReducer';
// import gallery from './gallery/galleryReducer';
// import blog from './blog/blogReducer';
// import highlight from './highlight/highlightReducer';
// import contact from './contact/contactReducer';
// import youtube from './youtube/youtubeReducer';
import events from './events/eventsReducer';
// import shop from './shop/shopReducer';
// import timer from './timer/timerReducer';
// import donation from './donation/donationReducer';
import htmlCode from './htmlCode/htmlCodeReducer';
import promoBar from './promoBar/promoBarReducer';
// import twitter from './twitter/twitterReducer';
// import nft from './nft/nftReducer';
import request from './request/requestReducer';
import splashScreen from './splashScreen/splashScreenReducer';
// import appointment from './appointment/appointmentReducer';
import subscribe from './subscribe/subscribeReducer';
// import form from './form/formReducer';
import welcomeMessage from './welcomeMessage/welcomeMessageReducer';

export const blocksReducers = {
  outfit,
  spacer,
  promoBar,
  course,
  splash,
  promo,
  text,
  link,
  links,
  dataCollect,
  contacts,
  customTabPreview,
  features,
  highlights,
  banner,
  map,
  slider,
  // feature,
  gallery,
  blog,
  chatAi,
  custom,
  review,
  html,
  // highlight,
  // contact,
  footer,
  faq,
  instagram,
  youtube,
  twitch,
  events,
  membership,
  pricing,
  twitter,
  trust,
  music,
  nft,
  wallet,
  request,
  appointment,
  subscribe,
  form,
  welcomeMessage,
  header,
  splashScreen,
  shop,
  tiktok,
  timer,
  donation,
  courses,
  htmlCode,
  digital,
  pageList,
  welcome,
  discountBlock,
  coupon,
  service,
  event,
  recipe,
  ama,
  wall,
  videoFeedback,
  status,
  crowdfunding,
  premiumInbox,

  video,
  file,
  stat,
  menu,
  podcast,
  timeline,
  booking,
  listing,
  overview,
  rental,
  singleProduct,
  team,
  timetable,
  unlock,
};
